import * as ROUTES from "../constants/routes";

const ROUTE_TREE = {
  root: {
    menu: "TOP",
    link: ROUTES.DASHBOARD,
    children: [
      {
        menu: "マスタトップ",
        link: ROUTES.MASTER_DASHBOARD,
        children: [
          {
            menu: "設備マスタトップ",
            link: ROUTES.MACHINE_MASTER_DASHBOARD,
            children: [
              {
                menu: "設備マスタ更新",
                link: ROUTES.MACHINE_MASTER_UPDATE,
                children: [],
              },
              {
                menu: "設備マスタ更新履歴検索",
                link: ROUTES.MACHINE_MASTER_HISTORY_SEARCH,
                children: [],
              },
              {
                menu: "設備マスタインポート",
                link: ROUTES.MACHINE_MASTER_IMPORT,
                children: [],
              },
              {
                menu: "設備マスタエクスポート",
                link: ROUTES.MACHINE_MASTER_EXPORT,
                children: [],
              },
              {
                menu: "設備グループマスタ更新",
                link: ROUTES.MACHINE_MASTER_GROUP_UPDATE,
                children: [],
              },
            ],
          },
          {
            menu: "部門マスタトップ",
            link: ROUTES.DEPARTMENT_MASTER_DASHBOARD,
            children: [
              {
                menu: "部門マスタ更新",
                link: ROUTES.DEPARTMENT_MASTER_UPDATE,
              },
              {
                menu: "部門マスタ更新履歴検索",
                link: ROUTES.DEPARTMENT_MASTER_HISTORY_SEARCH,
                children: [],
              },
              {
                menu: "部門マスタインポート",
                link: ROUTES.DEPARTMENT_MASTER_IMPORT,
                children: [],
              },
              {
                menu: "部門マスタエクスポート",
                link: ROUTES.DEPARTMENT_MASTER_EXPORT,
                children: [],
              },
            ],
          },
          {
            menu: "職位マスタトップ",
            link: ROUTES.POSITION_MASTER_DASHBOARD,
            children: [
              {
                menu: "職位マスタ更新",
                link: ROUTES.POSITION_MASTER_UPDATE,
                children: [],
              },
              {
                menu: "職位マスタ更新履歴検索",
                link: ROUTES.POSITION_MASTER_HISTORY_SEARCH,
                children: [],
              },
              {
                menu: "職位マスタインポート",
                link: ROUTES.POSITION_MASTER_IMPORT,
                children: [],
              },
              {
                menu: "職位マスタエクスポート",
                link: ROUTES.POSITION_MASTER_EXPORT,
                children: [],
              },
            ],
          },
          {
            menu: "承認設定マスタトップ",
            link: ROUTES.APPROVAL_SETTING_MASTER_DASHBOARD,
            children: [
              {
                menu: "承認設定マスタ更新",
                link: ROUTES.APPROVAL_SETTING,
                children: [
                  {
                    menu: "承認設定編集",
                    link: ROUTES.APPROVAL_SETTING_DETAIL,
                    children: [],
                  },
                ],
              },
              {
                menu: "承認設定マスタ更新履歴検索",
                link: ROUTES.APPROVAL_SETTING_MASTER_SEARCH,
              },
              {
                menu: "承認設定マスタインポート",
                link: ROUTES.APPROVAL_SETTING_MASTER_IMPORT,
              },
              {
                menu: "承認設定マスタエクスポート",
                link: ROUTES.APPROVAL_SETTING_MASTER_EXPORT,
              },
            ],
          },
          {
            menu: "点検テンプレートマスタトップ",
            link: ROUTES.INSPECTION_TEMPLATE_MASTER_DASHBOARD,
            children: [
              {
                menu: "点検テンプレートマスタ更新",
                link: ROUTES.TEMPLATE_MANAGEMENT,
                children: [
                  {
                    menu: "点検項目編集",
                    link: ROUTES.EDIT_INSPECTION_ITEM,
                    children: [],
                  },
                ],
              },
              {
                menu: "点検テンプレートマスタ更新履歴検索",
                link: ROUTES.INSPECTION_TEMPLATE_MASTER_SEARCH,
              },
              {
                menu: "点検テンプレートマスタインポート",
                link: ROUTES.INSPECTION_TEMPLATE_MASTER_IMPORT,
              },
              {
                menu: "点検テンプレートマスタエクスポート",
                link: ROUTES.INSPECTION_TEMPLATE_MASTER_EXPORT,
              },
            ],
          },
          {
            menu: "ユーザー",
            link: ROUTES.USERS_DASHBOARD,
            children: [
              {
                menu: "ユーザーマスタインポート",
                link: ROUTES.USER_MASTER_IMPORT,
              },
            ],
          },
        ],
      },
      {
        menu: "システム設定",
        link: ROUTES.SETTING,
        children: [],
      },
      {
        menu: "承認状況",
        link: ROUTES.JUDGMENT,
        children: [],
      },
      {
        menu: "マイページ",
        link: ROUTES.MY_PAGE,
        children: [],
      },
      {
        menu: "点検状況",
        link: ROUTES.INSPECTION_STATUS,
        children: [],
      },
      {
        menu: "点検表",
        link: ROUTES.INSPECTION_SHEET,
        children: [],
      },
    ],
  },
};

export const getRouteBreadcrumb = (leafLink) => {
  let root = ROUTE_TREE.root;
  const dfs = (node, path = []) => {
    if (node === null) {
      return null;
    }
    path.push(node);
    if (node.link === leafLink) {
      return path;
    }
    if (node.children) {
      for (let child of node.children) {
        let foundPath = dfs(child, path.slice());
        if (foundPath) {
          return foundPath;
        }
      }
    }
    return null;
  };
  return dfs(root);
};

const getPageBreadcrumb = (pageRoute, handleNavigate=null) => {
  let top = { menu: "TOP", link: ROUTES.DASHBOARD };
  let pageMenu;
  if (pageRoute === ROUTES.MASTER_DASHBOARD) {
    pageMenu = { menu: "マスタトップ" };
    return [top, pageMenu];
  }
  if (pageRoute === ROUTES.MACHINE_INPUT) {
    pageMenu = { menu: "[点検]設備入力" };
    return [top, pageMenu];
  }
  if (pageRoute === ROUTES.USER_MASTER_HISTORY_SEARCH) {
    let masterTop = { menu: "TOP", link: ROUTES.USERS_DASHBOARD };
    pageMenu = { menu: "ユーザーマスタ更新履歴検索" };
    return [masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.USER_MASTER_IMPORT) {
    let masterTop = { menu: "TOP", link: ROUTES.USERS_DASHBOARD };
    pageMenu = { menu: "ユーザーマスタインポート" };
    return [masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.USER_MASTER_UPDATE) {
    let masterTop = { menu: "TOP", link: ROUTES.USERS_DASHBOARD };
    pageMenu = { menu: "ユーザーマスタ更新" };
    return [masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.USER_MASTER_EXPORT) {
    let masterTop = { menu: "TOP", link: ROUTES.USERS_DASHBOARD };
    pageMenu = { menu: "ユーザーマスタエクスポート" };
    return [masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.CHANGE_PASSWORD) {
    pageMenu = { menu: "パスワード変更" };
    return [top, pageMenu];
  }
  if (pageRoute === ROUTES.USER_MASTER_SEARCH) {
    let masterTop = { menu: "TOP", link: ROUTES.USERS_DASHBOARD };
    pageMenu = { menu: "ユーザー検索" };
    return [masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.UNFINISHED_ACTION_LIST) {
    pageMenu = { menu: "処置未完了リスト" };
    return [top, pageMenu];
  }
  if (pageRoute === ROUTES.REGISTER_INSPECTION) {
    let masterTop = { menu: "[点検]設備入力", link: ROUTES.MACHINE_INPUT };
    pageMenu = { menu: "点検結果登録" };
    return [top, masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.UPDATE_INSPECTION) {
    let masterTop = { menu: "[点検]設備入力", link: ROUTES.MACHINE_INPUT };
    pageMenu = { menu: "点検結果登録" };
    return [top, masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.REGISTER_TREATMENT) {
    let masterTop = {
      menu: "処置未完了リスト",
      link: ROUTES.UNFINISHED_ACTION_LIST,
    };
    pageMenu = { menu: "処置" };
    return [top, masterTop, pageMenu];
  }
  if (pageRoute === ROUTES.SEARCH) {
    pageMenu = { menu: "詳細検索" };
    return [top, pageMenu];
  }
  if (pageRoute === ROUTES.SEARCH_INSPECTION_HISTORY_RESULT) {
    let searchTop = { menu: "詳細検索", link: ROUTES.SEARCH };
    pageMenu = { menu: "点検履歴検索結果" };
    return [top, searchTop, pageMenu];
  }
  if (pageRoute === ROUTES.SEARCH_MACHINES) {
    let search = { menu: "詳細検索", link: ROUTES.SEARCH };
    pageMenu = { menu: "検索結果" };
    return [top, search, pageMenu];
  }
  if (pageRoute === ROUTES.SEARCH_INSPECTION_HISTORY_CONFIRM) {
    let masterTop = { menu: "詳細検索", link: ROUTES.SEARCH };
    let previousTop = { menu: "点検履歴検索結果", handleNavigate: handleNavigate};
    pageMenu = { menu: "点検履歴" };
    return [top, masterTop, previousTop, pageMenu];
  }
  if (pageRoute === ROUTES.SEARCH_INSPECTION_HISTORY_CORRECTION) {
    let masterTop = { menu: "詳細検索", link: ROUTES.SEARCH };
    let previousTop = { menu: "点検履歴検索結果", handleNavigate: handleNavigate};
    pageMenu = { menu: "点検履歴(修正)" };
    return [top, masterTop, previousTop, pageMenu];
  }
  if (pageRoute === ROUTES.SEARCH_TREATMENT_HISTORY_DETAIL) {
    let searchTop = { menu: "詳細検索", link: ROUTES.SEARCH };
    let previousTop = { menu: "点検履歴検索結果", handleNavigate: handleNavigate};
    pageMenu = { menu: "処置履歴" };
    return [top, searchTop, previousTop, pageMenu];
  }
  return [];
};

export default getPageBreadcrumb;
